<script setup lang="ts">
import { useBoardDialogStore } from '@/stores/boardDialogStore';
import Read from '@/pages/navi-volunteer/qna/dialog/read/index.vue';
import Create from '@/pages/navi-volunteer/qna/dialog/create/index.vue';

const boardDialogStore = useBoardDialogStore();
const boardOption = computed(() => boardDialogStore.boardDialogOption);

onMounted(() => {
  //console.log('qna/board Mounted');
});

const handleClose = (isConfirm: boolean) => {
  //콜백함수가 있으면 먼저 실행
  console.log('handleClose 콜');
  console.log('isConfirm', isConfirm);
  boardOption.value.callback && isConfirm && boardOption.value.callback();
  boardDialogStore.closeBoardDialog();
};
</script>

<template>
  <v-dialog
    class="dialog"
    v-model="boardOption.open"
  >
    <v-card class="dialog__card align-center">
      <template v-if="boardOption.type === 'read' ">
        <Read />
      </template>
      <template v-else-if="boardOption.type === 'create' || boardOption.type === 'update'">
        <create />
      </template>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
@import '@/@core/scss/base/_mixins.scss';
@import '@/@core/scss/base/_variables.scss';
.dialog {
  width: 700px;
  max-width: 700px;
  @include respond-to(smartphone) {
    width: 80%;
  }
  &__card {
    border-radius: 0px;
    //NOTE:임시
    /* height: 100vw; */
    padding: 20px 30px 20px;
    display: flex;
    justify-content: flex-start;
    text-align: left;
    /* background-color: red; */
    /* text-align: center; */

    /* &__text {
      word-break: keep-all;
    }
    &__action {
      justify-content: center;
      button:first-of-type {
        width: 10vmin;
        @include respond-to(smartphone) {
          width: 15vmin;
        }
      }
      button:nth-of-type(2) {
        width: 8vmin;
        background-color: #6c5ce7;
        @include respond-to(smartphone) {
          width: 15vmin;
        }
      }
    } */
  }

  /* v-card-actions {
    margin: 0 auto;
  } */
}
</style>
